import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { getUserInfo } from "../../../actions/user";
import { message } from "antd";
import Progressbar from "../../widgets/progressbar";
import { BiCloudUpload } from "react-icons/bi";
import useAuth from "../../../hooks/useAuth";
import "../../../assets/scss/components/track/analyseForm.scss";
import { useNavigate } from "react-router-dom";
import url from "../../../utils/urls";
import { Track } from "../../../actions";

export const AnalyseForm: React.FC<any> = (props) => {
  const { dispatchUser } = useAuth() as any;
  const navigate = useNavigate();
  const [uploadPercent, setUploadPercent] = useState<number>(0);
  const [uploadFile, setUploadFile] = useState<File>();
  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      acceptedFiles?.map((file) => {
        const reader = new FileReader();
        reader.onload = function (e) {
          setUploadFile(file);
          Track.analyzeFile(file, (e) => {
            setUploadPercent(e.loaded / e.total * 100);
          }).then((info) => {
            setUploadPercent(100);
            getUserInfo().then((response) => {
              dispatchUser(response.data.userInfo);
            }).catch(console.warn);
            navigate(url.track.newFrontend(info.id));
          }).catch(() => {
            message.success("Error to upload file", 3);
            setUploadPercent(0);
          })
        };
        reader.readAsDataURL(file);
        return file;
      });
    },
    [dispatchUser]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "audio/mp3": [".mp3"],
      "audio/wma": [".wma"],
      "audio/wav": [".wav"],
    },
  });

  return (
    <div
      className={
        "file-upload-box text-center " +
        (props.className ? props.className : "")
      }
    >
      <div
        {...getRootProps({ className: "dropzone", accept: "mp3/*" })}
        {...(uploadFile ? { onClick: (e) => e.preventDefault() } : {})}
        className={
          "focus file-upload-wrapper" + (isDragActive ? " drag-active" : "")
        }
      >
        <div className="uk-container-large">
          {uploadPercent > 0 ? (
            <>
              <p className="dropzone-content mt-3">{uploadFile?.name}</p>
              <Progressbar width={uploadPercent} />
            </>
          ) : (
            <>
              <div className="tw-flex tw-justify-center">
                <BiCloudUpload className="upload-icon" size={70} />
              </div>
              <input className="input-zone" {...getInputProps()} />
              <p className="dropzone-content">
                {isDragActive
                  ? "Release to drop the song here"
                  : "Drag your song here"}
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AnalyseForm;
